import { Paper, Box, Typography, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import LockIcon from '@mui/icons-material/Lock';
import { WidgetDef } from '../registry';
import { WIDGET_HELP } from '../registry/widgetHelp';

interface Props {
    def: WidgetDef;
    institutionId: string;
    editable: boolean;
    onRemove?: () => void;
    /** Set by an admin or head: shows a lock icon and no remove button. */
    locked?: boolean;
}

export default function WidgetCard({ def, institutionId, editable, onRemove, locked }: Props) {
    const Component = def.component;
    return (
        <Paper variant="outlined" {...WIDGET_HELP[def.id]} sx={{ p: 2, height: '100%', position: 'relative', '&:hover .rm': { opacity: 1 } }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                    <Typography variant="subtitle2" fontWeight={700}>{def.title}</Typography>
                    {def.subtitle && (
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>{def.subtitle}</Typography>
                    )}
                </Box>
                {locked && (
                    <Tooltip title="Locked by your admin or head: it cannot be removed">
                        <LockIcon fontSize="small" color="action" aria-label={`${def.title} is locked`} data-testid={`lock-${def.id}`} sx={{ mt: 0.25 }} />
                    </Tooltip>
                )}
                {editable && onRemove && !locked && (
                    <IconButton className="rm" size="small" aria-label={`Remove ${def.title}`} onClick={onRemove} sx={{ opacity: 0, transition: 'opacity .1s' }}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                )}
            </Box>
            <Component institutionId={institutionId} />
        </Paper>
    );
}
